export const format = {
  asInteger(n, maximumFractionDigits = 0) {
    if (!isNaN(Number(n))) {
      return new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: maximumFractionDigits,
        useGrouping: true
      }).format(n).replace(',', '.')
    }
    return n;
  },
  // Форматирует decimal-строку без потери точности: значение не прогоняется
  // через Number, поэтому длинная дробная часть остаётся как есть.
  // '2530.40291837' -> '2 530,40291837'
  asDecimal(value) {
    if (value === null || value === undefined || value === '') {
      return value;
    }
    const raw = String(value).trim();
    if (!/^-?\d+(\.\d+)?$/.test(raw)) {
      return raw;
    }
    const sign = raw.startsWith('-') ? '-' : '';
    const [intPart, fracPart] = raw.replace('-', '').split('.');
    const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fracPart ? `${sign}${grouped},${fracPart}` : `${sign}${grouped}`;
  },
  // Допустимый ввод для фильтров по сумме: цифры и один разделитель . или ,
  isAmountInput(value) {
    return value === '' || /^\d*[.,]?\d*$/.test(value);
  },
  // '100,50' -> 100.5
  parseAmount(value) {
    return Number(String(value).replace(',', '.'));
  },
  addZeroBefore(n) {
    return (n < 10 ? '0' : '') + n
  }
}